import { render, staticRenderFns } from "./53zhly.vue?vue&type=template&id=963e7bbe&"
import script from "./53zhly.vue?vue&type=script&lang=js&"
export * from "./53zhly.vue?vue&type=script&lang=js&"
import style0 from "./53zhly.vue?vue&type=style&index=0&id=963e7bbe&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports